import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import StatusBadge from "../../../../StatusBadge/StatusBadge";
import { jsx as _jsx } from "react/jsx-runtime";
function StatusBadgeCell(props) {
  return /*#__PURE__*/_jsx(StatusBadge, _extends({}, props));
}
StatusBadgeCell.displayName = "StatusBadgeCell";
export default StatusBadgeCell;